App.controller('ZochLifeInsuranceOccurrenceCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaLifeInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', '$filter', 'popUpService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaLifeInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService, $filter, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wystąpienie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.lifeInsurance.details';
    $scope.$emit('link', $scope.link);

    if (!$scope.stateParams.declaration) {
        $state.go('root.home.zoch.lifeInsurance.details');
    }

    $scope.maxDate = new Date();
    $scope.dateOfDeath = new Date();
    $scope.declaration = $scope.stateParams.declaration;
    $scope.reason = 'EMPLOYEE_RESIGNATION';

    if ($scope.declaration.status === 'WITHDRAWN') {
        $scope.reason = $scope.declaration.reason;
        $scope.dateOfDeath = $scope.declaration.dateOfDeath;
    }

    $scope.withdraw = function () {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var criteria = {
            id: $scope.stateParams.declaration.declaration.id,
            data: {
                reason: $scope.reason
            }
        };

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $filter('getDateFromBirthdate')($scope.dateOfDeath);
        }

        zochaLifeInsuranceService.withdraw(criteria).then(function (data) {
            if (data.status === 200) {
                $state.go('root.home.zoch.lifeInsurance.list');
            } else {
                if (data.data.message === 'WrongStatusException') {
                    $scope.showPopUp('', 'Niepoprawny status deklaracji', 'Deklaracja musi być aktywna aby oznaczyć wystąpienie.', '', '');
                } else {
                    popUpService.showPopUpWithError(data.data, {head:'Błąd!', content:'Niestety nie udało się oznaczyć wystąpienia, skontaktuj się z administratorem.'});
                }
            }
        });
    }
}]);
